var React = require('react');

function FacebookSecondary (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.8333 0H1.16667C0.522083 0 0 0.522083 0 1.16667V12.8333C0 13.4779 0.522083 14 1.16667 14H7.58333V8.75H5.83333V6.41667H7.58333V4.90758C7.58333 3.09925 8.68758 2.11458 10.3011 2.11458C11.074 2.11458 11.7378 2.17233 11.9315 2.198V4.088L10.8127 4.08858C9.93533 4.08858 9.76558 4.50567 9.76558 5.117V6.41667H12.3556L11.7723 8.75H9.76558V14H12.8333C13.4779 14 14 13.4779 14 12.8333V1.16667C14 0.522083 13.4779 0 12.8333 0Z"}));
}

FacebookSecondary.defaultProps = {"width":"14","height":"14","viewBox":"0 0 15 14","fill":"#FFC800"};

module.exports = FacebookSecondary;

FacebookSecondary.default = FacebookSecondary;
